import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgProgressModule } from 'ngx-progressbar';
import { FittingsModule } from '../fittings/fittings.module';
import { LegacyShellComponent } from './legacy-shell.component';
import { LegacyTopbarComponent } from './legacy-topbar.component';
import { LegacyLoginComponent } from './legacy-login.component';
import { LegacyFittingsComponent } from './legacy-fittings.component';
import {
  LegacyCustomerSelectorComponent,
  LegacyMachineSelectorComponent,
  LegacyRecipeSelectorComponent,
  LegacySubstrateSelectorComponent,
  LegacySpectrophotometerComponent,
  LegacyPairTableComponent,
  LegacyTableValuesComponent,
} from './legacy-fittings.controls.component';

/**
 * The original Bootstrap 4 UI, kept for the clients that are not on the
 * "Coating Studio" list (see UiService). It shares the services and the chart
 * component with the studio UI; only templates and controls differ.
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgProgressModule,
    FittingsModule,   // CairoChartComponent + CairoService
  ],
  declarations: [
    LegacyShellComponent,
    LegacyTopbarComponent,
    LegacyLoginComponent,
    LegacyFittingsComponent,
    LegacyCustomerSelectorComponent,
    LegacyMachineSelectorComponent,
    LegacyRecipeSelectorComponent,
    LegacySubstrateSelectorComponent,
    LegacySpectrophotometerComponent,
    LegacyPairTableComponent,
    LegacyTableValuesComponent,
  ],
  exports: [
    LegacyShellComponent,
  ],
})
export class LegacyModule { }
